const avatarColors = [
    { r: 63, g: 198, b: 248 }, // sky blue
    { r: 65, g: 21, b: 208 }, // indigo
    { r: 175, g: 48, b: 20 }, // rust
    { r: 167, g: 232, b: 49 }, // lime green
    { r: 251, g: 172, b: 246 }, // orchid pink
    { r: 246, g: 187, b: 134 }, // peach
    { r: 121, g: 157, b: 16 }, // olive
    { r: 52, g: 245, b: 14 }, // bright green
    { r: 174, g: 120, b: 62 }, // brown
    { r: 255, g: 136, b: 137 }, // salmon
    { r: 6, g: 150, b: 104 }, // sea green
    { r: 244, g: 212, b: 3 }, // gold
    { r: 251, g: 120, b: 16 }, // orange
    { r: 154, g: 211, b: 179 }, // mint
    { r: 32, g: 80, b: 46 }, // forest green
    { r: 17, g: 227, b: 140 }, // emerald
    { r: 42, g: 83, b: 138 }, // steel blue
    { r: 179, g: 181, b: 230 }, // lavender
    { r: 49, g: 94, b: 234 }, // royal blue
    { r: 254, g: 92, b: 222 }, // magenta
    { r: 157, g: 13, b: 108 }, // maroon purple
];
function hashCode(value) {
    let hash = 0;
    for (let index = 0; index < value.length; index++) {
        hash = value.charCodeAt(index) + hash;
    }
    return hash;
}
export function getAvatarRGBFromName(name) {
    const code = hashCode(name);
    return avatarColors[code % avatarColors.length];
}
